import React from 'react';
import { t } from 'i18next';
import { ActionsProps } from '@lib/components/ReactHookForm/FormContainer';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import Button, { ButtonTypes } from '@lib/components/Button/Button';

interface FormActionsProps extends ActionsProps {
  onCancel: () => void;
  isEditMode?: boolean;
}

export default function WidgetModalFormActions({
  loading,
  onCancel,
  isEditMode = false,
}: FormActionsProps) {
  const submitButtonText = isEditMode ? t('save-changes') : t('add-widget');

  return (
    <ActionsRow
      actions={[
        <Button
          key="cancel"
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          onClick={onCancel}
          disabled={loading}
          fullWidth
          leftIcon="close"
        />,
        <Button
          key="submit"
          buttonText={submitButtonText}
          buttonType={ButtonTypes.primaryFilled}
          type="submit"
          isLoading={loading}
          disabled={loading}
          fullWidth
          leftIcon="check"
        />,
      ]}
    />
  );
}
